/* Ezy Deanz Club — static site JS (vanilla, no build step) */

/* ---------- Central configuration: edit values here only ---------- */
const CONFIG = Object.assign({
  brandName: "Ezy Deanz",
  membershipName: "Ezy Deanz Club",
  weeklyPrice: 9.99,
  discountPercent: 20,
  currencySymbol: "$",
  checkoutUrl: "join.html",
}, window.EZY_CLUB_CONFIG || {}); // <- values injected by Liquid override the defaults above

const currency = (n) => `${CONFIG.currencySymbol}${Number(n || 0).toFixed(2)}`;

/* ---------- Analytics placeholder ---------- */
function trackEvent(name, payload = {}) {
  if (window.dataLayer) window.dataLayer.push({ event: name, ...payload });
  console.debug("[track]", name, payload);
}
window.trackEvent = trackEvent;

document.addEventListener("click", (e) => {
  const el = e.target.closest("[data-track]");
  if (el) trackEvent(el.dataset.track, { location: el.dataset.location || "" });
});

/* ---------- Checkout placeholder ---------- */
function handleMembershipCheckout(signup) {
  // Integrate your payment platform here (Stripe, Paddle, etc.).
  console.info("Membership signup:", signup);
  return { redirected: false };
}

/* ---------- Header scroll state ---------- */
const header = document.querySelector(".site-header");
if (header) {
  const onScroll = () => header.classList.toggle("scrolled", window.scrollY > 12);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
}

/* ---------- Mobile drawer ---------- */
const drawer = document.getElementById("drawer");
const menuBtn = document.getElementById("menu-btn");
if (drawer && menuBtn) {
  const close = () => {
    drawer.classList.remove("open");
    menuBtn.setAttribute("aria-expanded", "false");
  };
  menuBtn.addEventListener("click", () => {
    drawer.classList.add("open");
    menuBtn.setAttribute("aria-expanded", "true");
  });
  drawer.addEventListener("click", (e) => {
    if (e.target.matches(".drawer-backdrop, .drawer-close") || e.target.closest("a")) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
}

/* ---------- Reveal on scroll ---------- */
const revealables = document.querySelectorAll(".reveal");
if (revealables.length) {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 },
  );
  revealables.forEach((el) => io.observe(el));
}

/* ---------- Sticky mobile CTA ---------- */
const sticky = document.getElementById("sticky-cta");
if (sticky) {
  const footer = document.getElementById("site-footer");
  const update = () => {
    const pastHero = window.scrollY > window.innerHeight * 0.75;
    const footerVisible = footer
      ? footer.getBoundingClientRect().top < window.innerHeight - 40
      : false;
    sticky.classList.toggle("show", pastHero && !footerVisible);
  };
  update();
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
}

/* ---------- Savings calculator ---------- */
const spendInput = document.getElementById("weekly-spend");
const spendRange = document.getElementById("weekly-spend-range");
if (spendInput && spendRange) {
  const rate = CONFIG.discountPercent / 100;
  const out = {
    discount: document.getElementById("out-discount"),
    fee: document.getElementById("out-fee"),
    annual: document.getElementById("out-annual"),
  };
  if (out.fee) out.fee.textContent = currency(CONFIG.weeklyPrice);

  let animatedDiscount = 50 * rate;
  let raf;
  let tracked = false;

  const countTo = (target) => {
    cancelAnimationFrame(raf);
    const start = animatedDiscount;
    const t0 = performance.now();
    const step = (now) => {
      const p = Math.min(1, (now - t0) / 380);
      const eased = 1 - Math.pow(1 - p, 3);
      animatedDiscount = start + (target - start) * eased;
      out.discount.textContent = currency(animatedDiscount);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
  };

  const render = (spend) => {
    const discount = spend * rate;
    out.annual.textContent = currency(discount * 52);
    countTo(discount);
    if (!tracked && spend !== 50) {
      tracked = true;
      trackEvent("club_calculator_used", { weeklySpend: spend });
    }
  };

  const setSpend = (raw, source) => {
    let v = Number(raw);
    if (!Number.isFinite(v)) v = 0;
    v = Math.max(0, Math.min(500, v));
    if (source !== "input") spendInput.value = v;
    spendRange.value = Math.min(300, v);
    render(v);
  };

  spendInput.addEventListener("input", () => setSpend(spendInput.value, "input"));
  spendRange.addEventListener("input", () => setSpend(spendRange.value));
  setSpend(50);
}

/* ---------- FAQ tracking ---------- */
document.querySelectorAll(".faq details").forEach((d) => {
  d.addEventListener("toggle", () => {
    if (d.open) trackEvent("club_faq_open", { question: d.querySelector("summary")?.textContent?.trim() });
  });
});

/* ---------- Join form ---------- */
const joinForm = document.getElementById("join-form");
if (joinForm) {
  joinForm.addEventListener("submit", (e) => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(joinForm).entries());
    trackEvent("club_signup_started", { plan: CONFIG.membershipName });
    const result = handleMembershipCheckout(data);
    if (!result.redirected) {
      trackEvent("club_signup_completed", { plan: CONFIG.membershipName });
      window.location.href = "success.html";
    }
  });
}

/* ---------- Year in footer ---------- */
document.querySelectorAll("[data-year]").forEach((el) => {
  el.textContent = new Date().getFullYear();
});
